import { render } from "./PDeleteFavAll.vue?vue&type=template&id=40bd61c4"
import script from "./PDeleteFavAll.vue?vue&type=script&lang=js"
export * from "./PDeleteFavAll.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__